const MACHINE_UDI_PATTERN = /^[A-Za-z0-9._-]+$/;

export const ENROLLMENT_ERROR_MESSAGES = {
  400: 'Machine UDI is missing, empty, or has characters outside letters, digits, ., _, and -.',
  401: 'The dashboard JWT is invalid or expired.',
  403: 'The token is missing, or the role is not admin or production.',
  404: 'Register the UDI first.',
  409: 'A certificate is already issued.',
};

export class EnrollmentTokenError extends Error {
  constructor(status, message) {
    super(message);
    this.name = 'EnrollmentTokenError';
    this.status = status;
  }
}

export const isPatientMonitorUdi = (machineUDI) => String(machineUDI || '').trim().startsWith('P0');

export const isUnregisteredNx5Machine = (item) => (
  item?.isTemporary === false
  && item?.isPermanent === false
  && isPatientMonitorUdi(item?.machineUDI)
);

export const isValidMachineUdi = (value) => MACHINE_UDI_PATTERN.test(String(value || ''));

/**
 * Keep the enrollment code a 6-character string. Digit-only values shorter
 * than 6 are padded so a leading zero is not dropped. Never pass the code
 * through Number().
 */
export const formatEnrollmentToken = (value) => {
  if (value == null) return '';
  const token = typeof value === 'number' && Number.isFinite(value)
    ? String(Math.trunc(value))
    : String(value);
  if (!/^\d+$/.test(token) || token.length >= 6) return token;
  return token.padStart(6, '0');
};

export const enrollmentErrorMessage = (status) => (
  ENROLLMENT_ERROR_MESSAGES[status] || 'Could not generate an enrollment code.'
);

export const formatEnrollmentCountdown = (expiresAt, nowMs) => {
  const end = Date.parse(expiresAt);
  if (Number.isNaN(end)) return '—';
  const remainingMs = end - nowMs;
  if (remainingMs <= 0) return 'Expired';

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (part) => String(part).padStart(2, '0');
  if (hours > 0) return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  return `${pad(minutes)}:${pad(seconds)}`;
};

export const readEnrollmentBody = (payload) => {
  const candidates = [payload, payload?.data, payload?.data?.data];
  return candidates.find((item) => (
    item && typeof item === 'object' && item.enrollment_token != null
  )) || null;
};
